import { ENV_VALUES } from '@/config/env';
import { AwsAxiosConfig } from '@/node-repo/AwsAxiosConfig';
import {
  GetTranslationsByLangQuery,
  GetTranslationsByLangQueryResponse,
} from '@informme/shared/schemas/bunduril/public/get-translations-by-lang.schema';

export class BundurilRepo {
  private static instance: BundurilRepo;

  baseUrl: string;

  private constructor(baseUrl?: string) {
    this.baseUrl = baseUrl ?? ENV_VALUES.VUE_APP_BUNDURIL_BASE_URL;
  }

  public static getInstance(baseUrl?: string): BundurilRepo {
    if (!BundurilRepo.instance) {
      BundurilRepo.instance = new BundurilRepo(baseUrl);
    }
    return BundurilRepo.instance;
  }

  getTranslations(
    requestBody: GetTranslationsByLangQuery,
  ): Promise<GetTranslationsByLangQueryResponse | undefined> {
    return AwsAxiosConfig.safeRequest({
      method: 'get',
      url: `${this.baseUrl}/api/v2/public/translations`,
      params: requestBody,
    });
  }
}
